import React from 'react'

const Skill = () => {
  return (
    <div id="skill">
      <p class="fontSize2 titlePosition">SKILL</p>
      <div class="skill">
        <p class="fontSize3">HTML/CSS/JavaScript</p>
        <p class="fontSize3">Java</p>
        <p class="fontSize3">Python</p>
        <p class="fontSize4">JavaScriptのライブラリはReactを使用した経験があり、フレームワークはVue、Svelteを使用した経験があります。</p>
      </div>
        
    </div>
  )
}

export default Skill